/*@ngInject*/
const RuleRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.findRuleById = function (id) {
        var url = '/rest/Rule/' + id,
            config = {
                params: {}
            };

        return this.get(url, config);
    };

    this.deleteRule = function (id) {
        var url = '/rest/Rule/' + id;
        return this.delete(url, id);
    };

    this.activateRule = function (id) {
        var url = '/rest/Rule/' + id + '/activate';
        return this.post(url, id);
    };

    this.deactivateRule = function (id) {
        var url = '/rest/Rule/' + id + '/deactivate';
        return this.post(url, id);
    };

    this.getRuleActions = function (ruleType) {
        var url = '/rest/Rule/ruleActions',
            config = {
                params: {
                    ruleType: ruleType
                }
            };
        return this.get(url, config);
    };

    this.getConditionTypes = function () {
        var url = '/rest/Rule/conditionTypes';
        return this.get(url);
    };

    this.updateRule = function (rule) {
        var url = '/rest/Rule/' + rule.id;

        return this.post(url, rule);
    };

    this.getOperators = function (type, isField) {
        var url = '/rest/Rule/operators',
            config = {
                params: {
                    type: type,
                    isField: isField
                }
            };

        return this.get(url, config);
    };

    this.getSearchableValues = function (formTemplateUniqueName, fieldName) {
        var url = '/rest/Rule/searchableValues',
            config = {
                params: {
                    formTemplateUniqueName: formTemplateUniqueName,
                    fieldName: fieldName
                }
            };

        return this.get(url, config);
    };

    this.getRulesByFilterUri = function (filterUri, requestParams) {
        var url = '/rest/Rule/filter',
            config = {
                params: {
                    filterUri: filterUri,
                    sortBy: requestParams.key,
                    sortDirection: requestParams.sortType,
                    startIndex: requestParams.startIndex,
                    numberOfRows: requestParams.pageSize
                }
            };

        return this.get(url, config);
    };

    this.createRule = function (rule) {
        var url = '/rest/Rule';
        return this.post(url, rule);
    };

    this.getMatchingTags = function (tagName) {
        var url = '/rest/RuleTag/getMatchingTags',
            config = {
                params: {
                    tagName: tagName
                }
            };
        return this.get(url, config);
    };

    this.createTag = function (tag) {
        var url = '/rest/RuleTag';
        return this.post(url, tag);
    };

    this.redeployRuleSets = function (ruleSetIds) {
        var url = '/rest/Rule/redeploy',
            config = {
                params: {
                    ruleSetIds: ruleSetIds
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };

    };

angular.module('ums.configuration')
    .service('ruleRepository', RuleRepository);
